import { Box, Typography } from '@mui/material';
import { useTranslation } from 'react-i18next';

export const ServiceGuideBox = () => {
  const { t } = useTranslation();
  return (
    <Box sx={{ mb: 2 }}>
      <Box sx={{ mb: 2 }}>
        <Typography variant="body1" paragraph sx={{ mb: 0 }}>
          {t('idIssuance.serviceGuide.section1.paragraph1')}
        </Typography>
        <Typography variant="body1" paragraph sx={{ mb: 0 }}>
          {t('idIssuance.serviceGuide.section1.paragraph2')}
        </Typography>
        <Typography variant="body1" paragraph sx={{ mb: 0 }}>
          {t('idIssuance.serviceGuide.section1.paragraph3')}
        </Typography>
      </Box>

      <Box sx={{ mb: 2 }}>
        <Typography variant="body1" paragraph sx={{ mb: 0 }}>
          {t('idIssuance.serviceGuide.section2.paragraph1')}
        </Typography>
        <Typography variant="body1" paragraph sx={{ mb: 0 }}>
          {t('idIssuance.serviceGuide.section2.paragraph2')}
        </Typography>
      </Box>
      <Box>
        <Typography
          variant="body2"
          color="error"
          sx={{
            mt: 2,
            fontWeight: 'medium',
          }}>
          {t('idIssuance.serviceGuide.section3.paragraph1')}
        </Typography>
        <Typography
          variant="body2"
          color="error"
          sx={{
            fontWeight: 'medium',
          }}>
          {t('idIssuance.serviceGuide.section3.paragraph2')}
        </Typography>
      </Box>
    </Box>
  );
};
